export default [
  {
    path: '/subscription-catalogues/user',
    name: 'User Report',
    component: () =>
      import(
        /* webpackChunkName: 'subscription-catalogues-user' */ './views/User.vue'
      )
  },
  {
    path: '/subscription-catalogues/library-share',
    name: 'Library Share Report',
    component: () =>
      import(
        /* webpackChunkName: 'subscription-catalogues-library-share' */
        './views/LibraryShare.vue'
      )
  }
]
